<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.configuration')} / ${$t('menu.permisos')}`"
      >
        <PermisosList></PermisosList>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import PermisosList from './tablas/PermisosList.vue'

export default {
  components: {
    AppCardCode,
    PermisosList,
  },
}
</script>
